import { ADMIN_FORMS, ADMIN_FLASH, ADMIN_BREADCRUMB } from '../../constants/actions';
import { apiActionCreator } from '../helpers';
import { currentPath } from '../../selectors/router';
import { removeLastPart } from '../../lib/route.utils';
import { push } from 'react-router-redux';
import { BAD_REQUEST_CODE, UNPROCESSABLE_ENTITY_CODE } from '../../constants/http.codes';
import { parseModelErrors } from '../../lib/error.utils';
import { apiMultipleCalls } from '../helpers';
import { omit } from 'lodash';

export function setModelData(model, data) {
    return {
        type: ADMIN_FORMS.FETCH_OK,
        data,
        model
    };
}

export function formSetField(value, field) {
    return {
        type: ADMIN_FORMS.SET,
        field,
        value
    };
}
export function formUpdate(model, field, path, value) {
    return {
        type: ADMIN_FORMS.UPDATE,
        model,
        field,
        path,
        value
    };
}

export function fetchDependencies(apiCalls, dispatchOptions = {}) {
    return async (dispatch, getState) => {
        dispatch({ type: ADMIN_FORMS.FETCH_START, dependencies: true, sub: dispatchOptions.sub });
        apiMultipleCalls(dispatch, apiCalls, results => {
            const parsedResults = dispatchOptions.parseFunction ? dispatchOptions.parseFunction(results) : results;
            dispatch({
                type: ADMIN_FORMS.FETCH_OK,
                model: 'dependencies',
                sub: dispatchOptions.sub,
                dependencies: true,
                data: omit(parsedResults, 'totalResults'),
                ...dispatchOptions
            });
            dispatch({ type: ADMIN_BREADCRUMB.REFRESH });
            dispatchOptions.afterDone && dispatchOptions.afterDone(dispatch, getState);
        });
    };
}

export function onInput(model, field, value, silence) {
    return {
        type: ADMIN_FORMS.INPUT,
        model,
        field,
        value,
        silence
    };
}

export function onKeyValueInput(model, field, subField, index, value) {
    return {
        type: ADMIN_FORMS.INPUT_KEY_VALUE,
        model,
        field,
        subField,
        index,
        value
    };
}

export function reset(model) {
    return {
        type: ADMIN_FORMS.RESET,
        model
    };
}

export function refresh(model) {
    return {
        type: ADMIN_FORMS.REFRESH,
        model
    };
}

export function onKeyValueDelete(model, field, index) {
    return {
        type: ADMIN_FORMS.DELETE_KEY_VALUE,
        model,
        field,
        index
    };
}

export function submit(submitFunction, successMessage, options = {}) {
    return async (dispatch, getState) => {
        const errorFunction = e => {
            dispatch({ type: ADMIN_FORMS.FAILED, errors: parseModelErrors(e.message) });
        };
        dispatch({ type: ADMIN_FORMS.SUBMIT });

        await apiActionCreator(
            dispatch,
            submitFunction,
            response => {
                const doneFunction = () => _afterSubmit(dispatch, getState, response, successMessage, options);
                options.beforeDone ? options.beforeDone(response, dispatch, getState, doneFunction) : doneFunction();
                return options.afterDone ? options.afterDone(dispatch, getState, response) : true;
            },
            {
                [BAD_REQUEST_CODE]: errorFunction,
                [UNPROCESSABLE_ENTITY_CODE]: errorFunction
            }
        );
    };
}

export function fetchModel(fetchFunction, model, options = {}) {
    return async dispatch => {
        dispatch({ type: ADMIN_FORMS.FETCH_START });
        await apiActionCreator(dispatch, fetchFunction, response => {
            dispatch(setModelData(model, options.transform ? options.transform(response) : response));
            dispatch({ type: ADMIN_BREADCRUMB.REFRESH });
        });
    };
}

function _afterSubmit(dispatch, getState, response, successMessage, options) {
    const toPath = currentPath(getState());
    if (!options.cancelRedirect) {
        dispatch(
            push(
                removeLastPart(toPath, options.subContext ? 2 : 1) + options.goToDetails
                    ? response.id || (response.ids && response.ids[0])
                    : ''
            )
        );
    }
    dispatch({ type: ADMIN_FORMS.SUCCESS });
    dispatch({ type: ADMIN_FLASH.OPEN, message: successMessage });
}
